<nz-range-picker
  class="admin-date-range-picker"
  [ngModel]="value"
  [nzAllowClear]="allowClear"
  [nzDisabled]="disabled"
  [nzFormat]="format"
  [nzPlaceHolder]="placeholders"
  (ngModelChange)="handleChange($event)"
></nz-range-picker>
